import React, { FC, useState } from 'react'

import Button from 'components/uiKit/Button'
import Input from 'components/uiKit/Input'
import { t } from 'services/Translation'

import * as s from '../AccessGate.module.scss'

interface IUserInfoFormProps {
  initialEmail?: string
  initialName?: string
  ssoFlow?: boolean
  onSubmit: (email: string, name: string) => void
}

export const UserInfoForm: FC<IUserInfoFormProps> = ({ initialEmail, initialName, onSubmit }) => {
  const [name, setName] = useState(initialName ?? '')
  const [email, setEmail] = useState(initialEmail ?? '')

  const buttonLabel = t('contentSpace.public.login')

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (name && email) {
      onSubmit(email, name)
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className={s.formField}>
        <label className={s.label}>Name</label>
        <Input name='userName' onChange={(val) => setName(val)} value={name} required />
      </div>

      <div className={s.formField}>
        <label className={s.label}>Email</label>
        <Input
          name='userEmail'
          onChange={(val) => setEmail(val)}
          type='email'
          value={email}
          required
        />
      </div>

      <div className={s.actions}>
        <Button disabled={!name || !email} name='startWithInfo' type='submit'>
          {buttonLabel}
        </Button>
      </div>
    </form>
  )
}
